import { helper as buildHelper } from '@ember/component/helper';
import clsx from 'clsx';

/**
 * @param {{category?: string}} option
 * @param {number} currentIndex
 * @param {number} selectedIndex
 * @returns {string}
 */
export const dropdownClassnames = ([
  option,
  currentIndex,
  selectedIndex,
  baseClassName,
]) => {
  const hasAltKey = Boolean(option.altKey);
  const hasCategory = Boolean(option.category);
  const isSelected = currentIndex === selectedIndex;

  return clsx(
    baseClassName,
    hasCategory && `${baseClassName}--nested`,
    isSelected && `${baseClassName}--selected`,
    hasAltKey && `${baseClassName}--has-alt-key`,
  );
};

export default buildHelper(dropdownClassnames);
